import { render, staticRenderFns } from "./RebackPassWord.vue?vue&type=template&id=2de8d902&scoped=true"
import script from "./RebackPassWord.vue?vue&type=script&lang=js"
export * from "./RebackPassWord.vue?vue&type=script&lang=js"
import style0 from "./RebackPassWord.vue?vue&type=style&index=0&id=2de8d902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8d902",
  null
  
)

export default component.exports